<template>
  <div>
    <div class="d-flex justify-content-between my-3">
        <label class="align-self-center w-50 text-right" :class="{'error-message': creditLineRequiredBool}"> Credit Line (Required)</label>
        <el-select
            v-model="brand"
            value-key="_id"
            :class="{ 'element-error': creditLineRequiredBool }"
            @change="emitBrand()"
            style="max-width:150px; min-width:150px;"
        >
            <el-option
            v-for="(brand, index) in brands"
            :key="index"
            :label="brand.name"
            :value="brand"
            >
            </el-option>
        </el-select>
    </div>
    <div v-if="brands[0] && brands[0].credit" class="d-flex justify-content-between my-3">
        <label class="align-self-center w-50 text-right"> Available Credit </label>
        <div :class="brand && brand.credit != null ? 'text-right' : 'text-center'" style="min-width: 100px;">
          <span v-if="brand && brand.credit != null"> £{{ brand.credit | priceformat }} </span>
          <span v-else> - </span>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  data(){
      return {
        brand: null,
      }
    },
  props: ['brands', 'creditLineRequiredBool'],
  methods:{
    emitBrand(){
      this.$emit("emitBrand", this.brand);
    }
  }
}
</script>